<template>
  <div>
    <a-modal
      title="公告编辑"
      v-model="visible"
      width="1200px"
      height="800px"
      @ok="handleSubmit"
    >
      <a-form
        :form="form"
      >
        <a-form-item
          label="标题"
          :label-col="{ span: 2 }"
          :wrapper-col="{ span: 19 }"
        >
          <a-input
            v-decorator="[
              'note',
              {rules: [{ required: true, message: '请输入标题!' }]}]
            "
          />
        </a-form-item>
        <a-form-item
          :label-col="{ span: 2 }"
          :wrapper-col="{ span: 19 }"
          label="类型"
        >
          <a-radio-group v-decorator="['type',{rules: [{ required: true, message: '请选择推送类型!' }]}]">
            <a-radio value="1" >
              公告
            </a-radio>
            <a-radio value="2">
              通知
            </a-radio>
            <a-radio value="3">
              提醒
            </a-radio>
          </a-radio-group>
        </a-form-item>
      </a-form>
      <div class="receiver">
        <div class="receiver-left">
          内容：
        </div>
        <div class="receiver-right">
          <quill-editor
            v-model="content"
            class="quill-editor"
            ref="myQuillEditor"
            :options="editorOption"
            @change="onEditorChange"
          >
          </quill-editor>
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script>
import '../../../node_modules/quill/dist/quill.core.css'
import '../../../node_modules/quill/dist/quill.snow.css'
import '../../../node_modules/quill/dist/quill.bubble.css'
import { quillEditor } from 'vue-quill-editor'
import { editNotice } from '@/api/manage'

export default {
  components: {
    quillEditor
  },
  data () {
    return {
      visible: false,
      content: '',
      editorOption: {},
      formLayout: 'horizontal',
      form: this.$form.createForm(this),
      noticeID: 0
    }
  },
  methods: {
    show (record) {
      this.visible = true
      this.$nextTick(() => {
        if (record.type === '公告') {
          record.type = 1
        } else if (record.type === '通知') {
          record.type = 2
        } else {
          record.type = 3
        }
        this.form.setFieldsValue({ 'note': record.title, 'type': record.type.toString() })
        this.content = record.content
        this.noticeID = record.id
      })
    },
    onEditorChange ({ quill, html, text }) {
      // console.log('editor change!', quill, html, text)
      this.content = html
    },
    handleSubmit (e) {
      e.preventDefault()
      this.form.validateFields((err, values) => {
        if (!err) {
          this.upLoadNotice({ id: this.noticeID, title: values.note, type: values.type, content: this.content })
        }
      })
    },
    upLoadNotice (parmas) {
      // console.log(parmas)
      return editNotice(parmas)
        .then(res => {
          this.$message.success(res.msg)
          this.form.resetFields()
          this.visible = false
          this.$emit('ok')
        })
        .catch((e) => this.requestFailed(e))
        .finally(() => {
          this.loading = false
        })
    },
    requestFailed (err) {
      // console.log(err)
      // this.$notification['error']({
      //   message: '错误',
      //   description: ((err.response || {}).data || {}).msg || '请求出现错误，请稍后再试',
      //   duration: 4
      // })
    }
  }
}
</script>

<style scoped>
  .receiver-left {
    width: 8%;
    display: inline-block;
    text-align: right;
    vertical-align: top;
  }
  .receiver-right {
    margin-left: 5px;
    width: 80%;
    display: inline-block;
  }
  .quill-editor {
    width: 100%;
    height: 400px;
  }
  .btn {
    position: absolute;
    top: 92%;
    left: 12%;
  }
</style>
